// File: src/components/RoleBasedRoute.js

import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, Typography, Button, CircularProgress } from '@mui/material'; // Added CircularProgress import

const RoleBasedRoute = ({ allowedRoles }) => {
    const { user, loading, logout } = useAuth();
    
    // NOTE: Returning null or a loading spinner is acceptable here.
    if (loading) {
        // You can return a loading indicator here instead of null for better UX
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!user) {
        // Redirect to login if user is not authenticated
        return <Navigate to="/login" replace />;
    }

    // Check if the user's roles include any of the allowed roles
    const userHasAccess = allowedRoles.some(role => user.roles.includes(role));

    if (userHasAccess) {
        // Render child routes if access is granted
        return <Outlet />;
    } else {
        // Display 403 Access Denied page if role check fails
        return (
            <Box sx={{ p: 5, textAlign: 'center' }}>
                <Typography variant="h3" color="error">403 Access Denied</Typography>
                <Typography variant="h6">You do not have the required role to view this page.</Typography>
                <Button variant="contained" sx={{mt: 2}} onClick={logout}>Log Out</Button>
            </Box>
        );
    }
};

export default RoleBasedRoute;